module.exports = __webpack_public_path__ + "static/media/receive.665ed6aa.svg";